// extracted by mini-css-extract-plugin
module.exports = {"p117tng3":"p117tng3","i52v5fu":"i52v5fu","p1rm0ma7":"p1rm0ma7","loader":"loader"};